import styled from "styled-components";
import { ColorTheme, TextTheme, ShadowTheme, BorderRadiusTheme, SpacingTheme } from "../globaStyledComponents/globalStyledComponentsStyling";

export const ErrorFallbackPageWrapper = styled.div`
    width: 100vw;
    height: 100vh;
    padding: ${SpacingTheme.spacing_500.padding};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${SpacingTheme.spacing_500.gap};
`;

export const ErrorFallbackPageIconContainer = styled.div`
    width: 48px;
    height: 48px;
`;

export const ErrorFallbackPageTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
`;

export const ErrorFallbackPageBtn = styled.button`
    height: 48px;
    background-color: ${ColorTheme.Black.color};
    color: ${ColorTheme.White.color};
    padding: 0 32px;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    border: none;
    box-shadow: ${ShadowTheme.shadow_100.boxShadow};
    cursor: pointer;
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
`;

export const ErrorFallbackPageTitle = styled.h1`
    font-size: ${TextTheme.sans_700_semi.fontSize};
    line-height: ${TextTheme.sans_700_semi.lineHeight};
    font-family: ${TextTheme.sans_700_semi.fontFamily};
    color: ${ColorTheme.Black.color};
`;

export const ErrorFallbackPageText = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    font-family: ${TextTheme.sans_300.fontFamily};
    color: ${ColorTheme.Grey.color};
`;